import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {TimelineLite} from "gsap";
import {ThorGameMode} from "../../gamemode/ThorGameMode";
import {ThorFSBonusFeaturePlayingController} from "../../reelstoppresentation/fsbonusfeature/ThorFSBonusFeaturePlayingController";
import {ThorParsedGameData} from "../../server/data/ThorParsedGameData";
import {ThorGameModuleConfig} from "../../ThorGameModuleConfig";
import {ThorRandomWildsWPController} from "../randomwilds/ThorRandomWildsWPController";

/**
 * Created by Jerker Nord on 2019-06-24.
 */

export class ThorMultiplierWPController extends WinPresentationController {

    private _multiplierPLaying:boolean = false;
    private _shouldPlayMultiplier:boolean;
    private _payoutMultiplierAfter:number;
    private _FSFeatureSelectEnded:boolean = false;
    private _FSMjolnirAnimationAborted:boolean = false;
    private _addNewMultiplierTL:TimelineLite;

    constructor(indexes:[number, number]) {
        super(indexes, {name : "ThorMultiplierWPController", skippable : true});
    }

    protected parseFeatureGameData(data:ThorParsedGameData):void {
        this._multiplierPLaying = false;
        this._shouldPlayMultiplier = false;
        this._FSMjolnirAnimationAborted = false;
        this._payoutMultiplierAfter = data.payoutMultiplierAfter;
        if(data.mode == ThorGameMode.NORMAL && data.nextMode == ThorGameMode.NUDGE_RESPIN && data.nudgeFeatureRewarded == ThorParsedGameData.NUDGE_REWARDED_RANDOM_MULTIPLIER_FEATURE) {
            this._multiplierPLaying = true;
            this._shouldPlayMultiplier = true;
        }
        if((data.mode == ThorGameMode.FREESPIN || data.mode == ThorGameMode.NUDGE_RESPIN_FS) && data.nextMode == ThorGameMode.NUDGE_RESPIN_FS && data.nudgeFeatureRewarded == ThorParsedGameData.NUDGE_REWARDED_RANDOM_MULTIPLIER_FEATURE) {
            this._multiplierPLaying = true;
            this._shouldPlayMultiplier = true;
        }
    }

    protected addFeatureEventHandlers():void {
        EventHandler.addEventListener(this, ThorRandomWildsWPController.ICON_SELECT_ANIMATION_COMPLETE, ():void => this.onIconSelectanimationComplete());
        EventHandler.addEventListener(this, ThorFSBonusFeaturePlayingController.FS_FEATURE_SELECT_ENDED, ():void => this.onFSFeatureSelectEnded());
        EventHandler.addEventListener(this, ThorFSBonusFeaturePlayingController.FS_MJOLNIR_ANIMATION_ABORTED, ():void => this.onMjolnirAnimationAborted());
    }

    private onMjolnirAnimationAborted():void {
        this._FSMjolnirAnimationAborted = true;
    }

    private onFSFeatureSelectEnded():void {
        if(this._multiplierPLaying == true && this._shouldPlayMultiplier == true) {
            this._FSFeatureSelectEnded = true;
        }
    }

    private onIconSelectanimationComplete():void {
        if(this._multiplierPLaying == true && this._shouldPlayMultiplier == true) {
            if(this._addNewMultiplierTL && this._addNewMultiplierTL.isActive()) {
                this._addNewMultiplierTL.pause();
                this._addNewMultiplierTL.kill();
            }
            this._addNewMultiplierTL = new TimelineLite();
            this._addNewMultiplierTL.add(() => this._shouldPlayMultiplier = false);
            this._addNewMultiplierTL.add(() => this.finish());
        }
    }

    protected hasWin():boolean {
        return this._multiplierPLaying;
    }

    protected startWinPresentation():void {
        Logger.logDev(`${this.moduleName} startWinPresentation this._multiplierPLaying=${this._multiplierPLaying}, this._shouldPlayMultiplier=${this._shouldPlayMultiplier}, this._FSFeatureSelectEnded=${this._FSFeatureSelectEnded}`)
        if(this._multiplierPLaying == false && this._shouldPlayMultiplier == false) {
            this.finish();
        }
        if(this._FSFeatureSelectEnded == true) {
            this._FSFeatureSelectEnded = false;
            this.onIconSelectanimationComplete();
        }
    }

    protected stopWinPresentation(isAborted:boolean):void {
        if(isAborted == true) {
            if(this._FSMjolnirAnimationAborted == false) {
                ThorGameModuleConfig.thorMjolnirtimeView.abort();
            }
            if(this._multiplierPLaying == true) {
                if(this._addNewMultiplierTL && this._addNewMultiplierTL.isActive()) {
                    this._addNewMultiplierTL.pause();
                    this._addNewMultiplierTL.kill();
                }
            }
            ThorGameModuleConfig.thorMultiplierController.abort();
            ThorGameModuleConfig.thorMultiplierIconView.abort();
            ThorGameModuleConfig.thorMultiplierIconView.activateMultiplier(this._payoutMultiplierAfter);
        }
    }
}